import { render, staticRenderFns } from "./CampaignMaterialModal.vue?vue&type=template&id=ca2b09f2&scoped=true"
import script from "./CampaignMaterialModal.vue?vue&type=script&lang=js"
export * from "./CampaignMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignMaterialModal.vue?vue&type=style&index=0&id=ca2b09f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b09f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca2b09f2')) {
      api.createRecord('ca2b09f2', component.options)
    } else {
      api.reload('ca2b09f2', component.options)
    }
    module.hot.accept("./CampaignMaterialModal.vue?vue&type=template&id=ca2b09f2&scoped=true", function () {
      api.rerender('ca2b09f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/CampaignMaterialModal.vue"
export default component.exports